import React from "react";
import "../../Styles/stripe.css";

const Stripe = () => {
  return (
    <>
      <section className="stripe-section">
        <div className="container">
          <div className="row stripe-row">
            <div className="stripe-col col-sm-6 col-md-6 col-lg-6 col-xl-3">
              <div className="stripe-box">
                <div className="stripe-img">
                <img src="/images/place.png" alt="place-icon" />
                </div>

                <div className="stripe-title">
                  <h5>1450</h5>
                  <p>Commercial Lands</p>
                </div>
              </div>
            </div>
            <div className="stripe-col col-sm-6 col-md-6 col-lg-6 col-xl-3">
              <div className="stripe-box justify-content-center">
             <div className="stripe-img">
             <img src="/images/car-dealer.png" alt="dealer-icon" />
             </div>
                <div className="stripe-title">
                  <h5>1450</h5>
                  <p>Commercial Lands</p>
                </div>
              </div>
            </div>
            <div className="stripe-col col-sm-6 col-md-6 col-lg-6 col-xl-3">
              <div className="stripe-box justify-content-center">
                <div className="stripe-img">
                <img src="/images/city-building.png" alt="building-icon" />
                </div>
                <div className="stripe-title">
                  <h5>1450</h5>
                  <p>Commercial Lands</p>
                </div>
              </div>
            </div>
            <div className="stripe-col col-sm-6 col-md-6 col-lg-6 col-xl-3">
              <div className="stripe-box justify-content-end">
               <div className="stripe-img">
               <img src="/images/home-office.png" alt="office-icon" />
               </div>
                <div className="stripe-title">
                  <h5>1450</h5>
                  <p>Commercial Lands</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Stripe;
